import Card from "@material-ui/core/Card";
import Checkbox from "@material-ui/core/Checkbox";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import InputLabel from "@material-ui/core/InputLabel";
import Tooltip from "@material-ui/core/Tooltip";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import Select from "@material-ui/core/Select";
import withStyles from "@material-ui/core/styles/withStyles";
import Switch from "@material-ui/core/Switch";
import { withSnackbar } from "notistack";
import Helmet from "react-helmet";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import headersList from "../../../../../../Constants/headersList";
import { instance } from "../../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  CommonReducerAction,
} from "../../../../../../Actions/commonAction";
import CheckImg from "../../../../../../Assets/Images/aaa.png";
import defaultEmp from "../../../../../../Assets/Images/defaultEmp.svg";
import InputNumber from "../../../../../../Component/InputNumber";
import InputText from "../../../../../../Component/InputText";
import { ChangeLanguage } from "../../../../../../Actions/LanguageAction";
import Bag from "../../../../../../Assets/Svg/bag.svg";
import SelectList from "../../../../../../Component/SelectList/SelectList";
import { ReducersTypes } from "../../../../../../Constants";
import { LIST, SEPERATOR_OPTIONS } from "./data";
import "./index.css";
import { getFormattedImageLink } from "../../../../../../Utils";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    padding: theme.spacing.unit * 3,
  },
});

const formMarginBottom = {
  marginBottom: "20px",
};

class EmpCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      code: true,
      preview: false,
      expanded: false,
      show: false,
      hide: false,
      open: false,
      firstPlace: "",
      secondPlace: "",
      thirdPlace: "",
      commonseperator: "",
      selectseperator: "no separator",
      CommonError: "",
      CodeError: "",
      modetypeid: "",
      isPrifixSelected: false,
      isMidTextSelected: false,
      isSuffixSelected: false,
      anchorEl: null,
      seperatorOptions: SEPERATOR_OPTIONS,
      list: LIST,
      empcodepreviewlist: [],
      permissions: { readOnly: false, editable: false },
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.ValidateFormat(true);
    const [isTrue, permissions] = CheckActionPermission("employeeID");
    if (isTrue) {
      this.setState({ permissions }, () => this.GetCompnayDetails());
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillMount() {
    this.props.ChangeLanguage("empcode,navigation");
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);

    this.props.CommonReducerAction(`${ReducersTypes.LANGUAGE}_PENDING`);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  handleClick = (event) => this.setState({ anchorEl: event.currentTarget });

  handleClose() {
    this.setState({ anchorEl: null });
  }

  UpdateSeperatorValue(option) {
    // console.log('asf', option.target.value);
    const seperatorIndex = SEPERATOR_OPTIONS.findIndex(
      (seperator) => seperator.name === option.target.value,
    );
    let commonseperator;
    seperatorIndex == 4
      ? (commonseperator = "")
      : (commonseperator = SEPERATOR_OPTIONS[seperatorIndex].displayname);
    this.setState(
      { commonseperator, selectseperator: option.target.value },
      () => {
        this.Empcodepreview();
      },
    );
  }

  UpdateModetype(mode, event) {
    console.log("mode, event: ", mode, event);
    if (mode == 0) {
      this.ClearData();
      this.setState({
        expanded: true,
        show: false,
        modetypeid: 0,
        define: true,
      });
    }
    if (mode == 1) {
      // this.GetCodeDetails();
      this.setState({
        show: !this.state.show,
        expanded: true,
        modetypeid: 1,
        define: true,
      });
    }
  }

  ClearData() {
    const { list } = this.state;
    for (const listData of list) {
      listData.isUppercaseSelected = false;
    }
    this.setState(
      {
        list,
        firstPlace: "",
        secondPlace: "",
        thirdPlace: "",
        CommonError: "",
        commonseperator: "",
        modetypeid: "",
        isPrifixSelected: false,
        isMidTextSelected: false,
        isSuffixSelected: false,
        Empcodepreview: "",
        autoassign: false,
        selectseperator: "no separator",
      },
      () => {
        this.ValidateFormat();
      },
    );
  }

  EditCode() {
    this.setState({ code: true, preview: false });
  }

  GetCompnayDetails() {
    const URL = `subscription/initsubscriptionempcode`;
    instance
      .get(URL)
      .then((result) => {
        const CompnayDetails = result.data.result[0];
        this.setState({ CompnayDetails }, () => {
          this.GetCodeDetails();
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
        this.setState({ CommonError });
      });
  }

  Empcodepreview() {
    let firstPlace;
    let secondPlace;
    let thirdPlace;
    let CodeError;
    const CompnayInfo = [];
    // CompnayInfo.push("");
    CompnayInfo.push(
      this.state.CompnayDetails && this.state.CompnayDetails.companyname,
    );
    CompnayInfo.push(
      this.state.CompnayDetails && this.state.CompnayDetails.businessunitname,
    );
    CompnayInfo.push(
      this.state.CompnayDetails && this.state.CompnayDetails.locationname,
    );
    CompnayInfo.push(
      this.state.CompnayDetails && this.state.CompnayDetails.departmentname,
    );

    const listData0 = this.state.list[0];
    const listData1 = this.state.list[1];
    const listData2 = this.state.list[2];

    if (this.state.isPrifixSelected) {
      const x = listData0.findIndex((a) => a.isSelected == true);
      firstPlace = CompnayInfo[x];
      const obj = listData0[x];
      if (x == 0 || x == 1 || x == 2 || x == 3) {
        if (firstPlace) {
          firstPlace = firstPlace.replace(/\s/g, "");
          firstPlace = firstPlace.substring(0, obj.textValue);
        } else {
          if (x == 1) {
            this.props.enqueueSnackbar("Please Provide Business Unit ", {
              variant: "error",
            });
          }

          if (x == 3) {
            this.props.enqueueSnackbar("Please Provide Department ", {
              variant: "error",
            });
          }
          // console.log('pre')
          return;
        }
      } else if (x == 4 || x == 5) {
        firstPlace = obj.textValue;
      }
      if (firstPlace) {
        if (listData0.isUppercaseSelected) {
          firstPlace = firstPlace.toUpperCase();
        }
      }
    }

    if (this.state.isMidTextSelected) {
      const y = listData1.findIndex((a) => a.isSelected == true);
      secondPlace = CompnayInfo[y];
      const obj = listData1[y];
      if (y == 0 || y == 1 || y == 2 || y == 3) {
        if (secondPlace) {
          secondPlace = secondPlace.replace(/\s/g, "");
          secondPlace = secondPlace.substring(0, obj.textValue);
        } else {
          if (y == 1) {
            this.props.enqueueSnackbar("Please Provide Business Unit ", {
              variant: "error",
            });
          }

          if (y == 3) {
            this.props.enqueueSnackbar("Please Provide Department ", {
              variant: "error",
            });
          }
          // console.log('mid')
          return;
        }
      } else if (y == 4 || y == 5) {
        secondPlace = obj.textValue;
      }
      if (secondPlace) {
        if (listData1.isUppercaseSelected) {
          secondPlace = secondPlace.toUpperCase();
        }
      }
    }

    if (this.state.isSuffixSelected) {
      const z = listData2.findIndex((a) => a.isSelected == true);
      thirdPlace = CompnayInfo[z];
      const obj = listData2[z];
      if (z == 0 || z == 1 || z == 2 || z == 3) {
        if (thirdPlace) {
          thirdPlace = thirdPlace.replace(/\s/g, "");
          thirdPlace = thirdPlace.substring(0, obj.textValue);
        } else {
          if (z == 1) {
            this.props.enqueueSnackbar("Please Provide Business Unit ", {
              variant: "error",
            });
          }
          if (z == 3) {
            this.props.enqueueSnackbar("Please Provide Department ", {
              variant: "error",
            });
          }
          // console.log('syf')
          return;
        }
      } else if (z == 4 || z == 5) {
        thirdPlace = obj.textValue;
      }
      if (thirdPlace) {
        if (listData2.isUppercaseSelected) {
          thirdPlace = thirdPlace.toUpperCase();
        }
      }
    }

    let Empcodepreview = "";

    const tempArray = [];
    if (firstPlace) {
      tempArray.push(firstPlace);
    }
    if (secondPlace) {
      tempArray.push(secondPlace);
    }
    if (thirdPlace) {
      tempArray.push(thirdPlace);
    }
    if (tempArray.length > 1) {
      Empcodepreview = tempArray.join(this.state.commonseperator);
    } else {
      Empcodepreview = tempArray.join("");
    }
    const filteredArray = tempArray.filter((array) => Number(array));

    filteredArray.length == 0
      ? (CodeError = "employee ID should contain atleast one number")
      : (CodeError = "");
    // console.log('code', Empcodepreview)

    this.setState({
      Empcodepreview,
      firstPlace,
      secondPlace,
      thirdPlace,
      CodeError,
    });
  }

  FormatChange(name, event) {
    this.setState({ [name]: event.target.checked }, () => {
      this.ValidateFormat();
    });
  }

  ValidateFormat(isFromOnLoad) {
    const { list } = this.state;

    this.state.isPrifixSelected
      ? (list[0].isDisabled = false)
      : (list[0].isDisabled = true);
    this.state.isMidTextSelected
      ? (list[1].isDisabled = false)
      : (list[1].isDisabled = true);
    this.state.isSuffixSelected
      ? (list[2].isDisabled = false)
      : (list[2].isDisabled = true);

    if (list[0].isDisabled == true) {
      for (const listData of list[0]) {
        listData.isSelected = false;
        listData.textValue = "";
      }
    }
    if (list[1].isDisabled == true) {
      for (const listData of list[1]) {
        listData.isSelected = false;
        listData.textValue = "";
      }
    }
    if (list[2].isDisabled == true) {
      for (const listData of list[2]) {
        listData.isSelected = false;
        listData.textValue = "";
      }
    }

    this.setState({ list }, () => {
      // if (!isFromOnLoad) {
      this.Empcodepreview();
      // }
    });
  }

  FormatSelection(data1, listData, row, column, event) {
    const data = event.target.value;
    const ixList = [
      "isPrifixSelected",
      "isMidTextSelected",
      "isSuffixSelected",
    ];
    const newList = [...this.state.list].map((listInstance, i) => {
      if (i == column) {
        listInstance.map((x) => {
          x.isSelected = data.displayvalue === x.displayvalue;
          x.textValue = "";
        });
      } else {
        let shouldDisable = false;
        listInstance.map((x) => {
          if (x.key == data.key && x.isSelected) {
            x.isSelected = false;
            shouldDisable = true;
            this.setState({ [ixList[i]]: false });
          }
          return x;
        });
        listInstance.isDisabled = shouldDisable;
      }
      return listInstance;
    });
    this.setState({ list: newList }, () => {
      this.Empcodepreview();
    });
  }

  OnTextChange(data, listData, row, column, event) {
    const { list } = this.state;
    listData.map((x) => {
      x.textValue = "";
    });
    for (const item of list) {
      item[row].textValue = "";
    }
    // if (!Number.isNaN(event.target.value)) {
    //   data.textValue = "";
    // } else {
    data.textValue = event.target.value;
    // }

    listData[row] = data;
    list[column] = listData;
    this.setState({ list }, () => {
      this.Empcodepreview();
    });
  }

  HandleKeyDown(e) {
    if ([69, 187, 188, 189, 190, 107, 109, 110].includes(e.keyCode)) {
      e.preventDefault();
    }
  }

  OnNumberChange(data, listData, row, column, event) {
    const { list } = this.state;
    listData.map((x) => {
      x.textValue = "";
    });
    for (const item of list) {
      item[row].textValue = "";
    }

    if (event.target.value < 1 || Number.isNaN(event.target.value)) {
      data.textValue = "";
    } else if (event.target.value > 10) {
      data.textValue = "";
    } else {
      data.textValue = event.target.value;
    }

    listData[row] = data;
    list[column] = listData;
    this.setState({ list }, () => {
      this.Empcodepreview();
    });
  }

  OnNumberSeriesChange = (data, listData, row, column, event) => {
    const { list } = this.state;
    listData.map((x) => {
      x.textValue = "";
    });
    for (const item of list) {
      item[row].textValue = "";
    }

    if (
      event.target.value < 1 ||
      Number.isNaN(event.target.value) ||
      Number(event.target.value) > 999999999
    ) {
      data.textValue = "";
    } else {
      data.textValue = event.target.value;
    }

    listData[row] = data;
    list[column] = listData;
    // console.log('sdfds', list)
    this.setState({ list }, () => {
      this.Empcodepreview();
    });
  };

  UppercaseSelection(listData, column, event) {
    listData.isUppercaseSelected = event.target.checked;
    this.state.list[column] = listData;
    this.setState({ list: this.state.list }, () => {
      this.Empcodepreview();
    });
  }

  UpdateAssignmenttype(mode, event) {
    if (mode == 2) {
      this.setState({ hide: false, isincludedeactiveemp: "" });
    }
    if (mode == 1) {
      this.setState({ hide: !this.state.hide });
    }
    this.setState({ assignmenttypeid: mode, autoassign: true });
  }

  UpdateDeactivateEmp(selectedItem) {
    this.setState({ isincludedeactiveemp: selectedItem.displayvalue });
  }

  GetCodeDetails() {
    const URL = `subscription/employeecode`;
    instance
      .get(URL)
      .then((result) => {
        if (result.data.result.length == 0) {
          return false;
        }
        const data = result.data.result[0];
        let expanded;
        let show;
        let define;
        let autoassign;
        data.modetypeid == 0 || data.modetypeid == 1
          ? (define = true)
          : (define = false);
        data.assignmenttypeid ? (autoassign = true) : (autoassign = false);
        data.modetypeid == 0 ? (expanded = true) : (expanded = false);
        data.modetypeid == 1 ? (show = true) : (show = false);
        const { modetypeid } = data;
        const isPrifixSelected = data.isprefix;
        const isMidTextSelected = data.ismid;
        const isSuffixSelected = data.issuffix;
        let commonseperator =
          data.commonseperator == "" ? "" : data.commonseperator;
        const { assignmenttypeid } = data;
        const { isincludedeactiveemp } = data;
        const Empcodepreview = data.empcodepreview;
        const { nextcode } = data;
        const { list } = this.state;
        const listData0 = this.state.list[0];
        const listData1 = this.state.list[1];
        const listData2 = this.state.list[2];

        if (data.prefixtexttypeid) {
          const index0 = listData0.findIndex(
            (x) => x.displayvalue == data.prefixtexttypeid,
          );
          listData0[index0].displayvalue = data.prefixtexttypeid;
          listData0[index0].textValue = data.prefixtextvalue;
          listData0[index0].isSelected = true;
          listData0.isUppercaseSelected = data.isprefixuppercase;
          list[0] = listData0;
        }
        if (data.midtexttypeid) {
          const index1 = listData1.findIndex(
            (x) => x.displayvalue == data.midtexttypeid,
          );
          listData1[index1].displayvalue = data.midtexttypeid;
          listData1[index1].textValue = data.midtextvalue;
          listData1[index1].isSelected = true;
          listData1.isUppercaseSelected = data.ismiduppercase;
          list[1] = listData1;
        }
        if (data.suffixtexttypeid) {
          const index2 = listData2.findIndex(
            (x) => x.displayvalue == data.suffixtexttypeid,
          );
          listData2[index2].displayvalue = data.suffixtexttypeid;
          listData2[index2].textValue = data.suffixtextvalue;
          listData2[index2].isSelected = true;
          listData2.isUppercaseSelected = data.issuffixuppercase;
          list[2] = listData2;
        }
        const currentSeperator = SEPERATOR_OPTIONS.find(
          (op) => op.displayname == commonseperator,
        );
        let sepname = "";
        if (currentSeperator) {
          sepname = currentSeperator.name;
        } else {
          commonseperator = "";
          sepname = "no separator";
        }

        console.log("compensator", currentSeperator);
        this.setState(
          {
            nextcode,
            expanded,
            show,
            define,
            autoassign,
            modetypeid,
            midtextvalue: data.midtextvalue,
            prefixtextvalue: data.prefixtextvalue,
            suffixtextvalue: data.suffixtextvalue,
            isPrifixSelected,
            isMidTextSelected,
            isSuffixSelected,
            commonseperator,
            assignmenttypeid,
            isincludedeactiveemp,
            Empcodepreview,
            list,
            selectseperator: sepname,
          },
          () => {
            console.log("thisstate.sele", this.state.selectseperator);
            this.ValidateFormat();
          },
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        console.log(`Error occured ${CommonError}`);
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
        this.setState({ CommonError });
      });
  }

  Validate() {
    let isValid = true;
    const { CommonError } = this.state;
    if (this.state.modetypeid != 0 && this.state.modetypeid != 1) {
      this.setState({
        CommonError: "Please Select How Would You Like To Define Employee ID",
      });
      return (isValid = false);
    }
    this.setState({ CommonError: "" });

    if (this.state.CodeError) {
      this.setState({ CommonError: this.state.CodeError });
      return (isValid = false);
    }
    this.setState({ CommonError: "" });

    if (!this.state.assignmenttypeid) {
      this.setState({
        CommonError: "Please Select Start From The Oldest Joining Date",
      });
      return (isValid = false);
    }
    this.setState({ CommonError: "" });

    return isValid;
  }

  OnSubmit() {
    if (!this.Validate() && this.state.modetypeid == 1) {
      setTimeout(
        () =>
          this.props.enqueueSnackbar(this.state.CommonError, {
            variant: "error",
          }),
        300,
      );
    } else {
      let prefixtexttypeid;
      let midtexttypeid;
      let suffixtexttypeid;
      let isprefixuppercase;
      let ismiduppercase;
      let prefixtextvalue;
      let midtextvalue;
      let issuffixuppercase;
      let suffixtextvalue;
      const listData0 = this.state.list[0];
      const listData1 = this.state.list[1];
      const listData2 = this.state.list[2];
      isprefixuppercase = listData0.isUppercaseSelected;
      ismiduppercase = listData1.isUppercaseSelected;
      issuffixuppercase = listData2.isUppercaseSelected;

      for (const item of listData0) {
        if (item.isSelected) {
          prefixtexttypeid = item.displayvalue;
        }
        if (item.isSelected) {
          prefixtextvalue = item.textValue;
        }
      }
      for (const item of listData1) {
        if (item.isSelected) {
          midtexttypeid = item.displayvalue;
        }
        if (item.isSelected) {
          midtextvalue = item.textValue;
        }
      }
      for (const item of listData2) {
        if (item.isSelected) {
          suffixtexttypeid = item.displayvalue;
        }
        if (item.isSelected) {
          suffixtextvalue = item.textValue;
        }
      }
      let { nextcode } = this.state;
      if (
        prefixtexttypeid == 6 &&
        (!nextcode || prefixtextvalue != this.state.prefixtextvalue)
      ) {
        nextcode = prefixtextvalue - 1;
      }
      if (
        midtexttypeid == 6 &&
        (!nextcode || midtextvalue != this.state.midtextvalue)
      ) {
        nextcode = midtextvalue - 1;
      }
      if (
        suffixtexttypeid == 6 &&
        (!nextcode || suffixtextvalue != this.state.suffixtextvalue)
      ) {
        nextcode = suffixtextvalue - 1;
      }

      const data = {
        nextcode,
        modetypeid: this.state.modetypeid,
        isprefix: this.state.isPrifixSelected,
        ismid: this.state.isMidTextSelected,
        issuffix: this.state.isSuffixSelected,
        prefixtexttypeid,
        prefixtextvalue,
        isprefixuppercase,
        midtexttypeid,
        midtextvalue,
        ismiduppercase,
        suffixtexttypeid,
        suffixtextvalue,
        issuffixuppercase,
        commonseperator: this.state.commonseperator,
        assignmenttypeid: this.state.assignmenttypeid,
        isincludedeactiveemp: this.state.isincludedeactiveemp
          ? this.state.isincludedeactiveemp
          : false,
        empcodepreview: this.state.Empcodepreview,
      };

      if (this.state.isPrifixSelected && !prefixtextvalue) {
        this.props.enqueueSnackbar("Please add Prefix value", {
          variant: "error",
        });
        return;
      }
      if (this.state.isMidTextSelected && !midtextvalue) {
        this.props.enqueueSnackbar("Please add mid value", {
          variant: "error",
        });
        return;
      }
      if (this.state.isSuffixSelected && !suffixtextvalue) {
        this.props.enqueueSnackbar("Please add sufix value", {
          variant: "error",
        });
        return;
      }

      const URL = `subscription/employeecode`;
      instance
        .post(URL, data)
        .then((result) => {
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          if (this.state.modetypeid == 0) {
          } else {
            let empcodepreviewlist = [];
            result.data.result
              ? (empcodepreviewlist = result.data.result)
              : (empcodepreviewlist = []);
            this.setState({ empcodepreviewlist, preview: true, code: false });
          }
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  AutoAssignFlag() {
    this.setState({ autoassign: true });
  }

  AssignEmpCode() {
    this.props.enqueueSnackbar(
      "Updating Employee ID for existing employees will override any Employee ID that you might have manually assigned.",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              this.props.closeSnackbar();
              const URL = `subscription/assignsubscriptionempcode`;
              instance
                .post(URL)
                .then(() => {
                  this.props.enqueueSnackbar("Assigned successfully", {
                    variant: "success",
                  });
                })
                .catch((error) => {
                  const CommonError = error.response
                    ? error.response.data.error.message
                    : error.message;
                  this.props.enqueueSnackbar(CommonError, { variant: "error" });
                });
            }}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() =>
              this.setState({ createmenu: false }, () =>
                this.props.closeSnackbar(),
              )
            }
          >
            No
          </Button>,
        ],
      },
    );
  }

  getInputComponent = (data, listData, row, column) =>
    data.displayvalue == 6 ? (
      <div className="inlineClass width100">
        <div className="emp-code-input-range margin-top-8">
          <p className="input-form-label t-14 floatleft margin-top-16 margin-right-8 text-color-grey">
            <FormattedMessage
              id="Lbinputnumber1"
              defaultMessage="Number starts from"
            />
          </p>
          <InputNumber
            min={1}
            max="100000"
            // width="70px"
            value={data.textValue}
            disabled={listData.isDisabled}
            onChange={(event) =>
              this.OnNumberSeriesChange(data, listData, row, column, event)
            }
            onKeydown={this.HandleKeyDown.bind(this)}
          />
        </div>
      </div>
    ) : (
      <div className="inlineClass width100">
        {data.displayvalue == 5 ? (
          <div>
            <p
              className="input-form-label floatleft t-12"
              style={{
                marginTop: 8,
                marginBottom: 0,
              }}
            >
              <FormattedMessage id="inputtext" defaultMessage="Custom Text" />
            </p>
            <InputText
              className="input-text"
              width="92%"
              maxLength="10"
              value={data.textValue}
              disabled={listData.isDisabled}
              onChange={(event) =>
                this.OnTextChange(data, listData, row, column, event)
              }
              onKeydown={this.HandleKeyDown.bind(this)}
            />
          </div>
        ) : (
          <div className="emp-code-input-range margin-top-8">
            <p className="input-form-label t-14 floatleft margin-top-16 margin-right-8 text-color-grey">
              <FormattedMessage
                id="inputnumber"
                defaultMessage="Number of Characters"
              />
            </p>
            <InputNumber
              min={1}
              max="10"
              // width="70px"
              value={data.textValue}
              disabled={listData.isDisabled}
              onChange={(event) =>
                this.OnNumberSeriesChange(data, listData, row, column, event)
              }
              onKeydown={this.HandleKeyDown.bind(this)}
            />
          </div>
        )}
      </div>
    );

  render() {
    const language = this.props.Language.empcode;
    const options = [
      {
        displayvalue: true,
        displayname: <FormattedMessage id="LbYes" defaultMessage="Yes" />,
      },
      {
        displayvalue: false,
        displayname: <FormattedMessage id="LbNo" defaultMessage="No" />,
      },
    ];
    return (
      <IntlProvider locale="en" messages={language}>
        <main className="content-outer-wrapper">
          <Helmet>
            <title>{headersList.Config.Employeeid.header}</title>
          </Helmet>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              <Grid item xs={12} md={12} sm={12}>
                <div className="type-form-wrapper emp-code-form-wrapper">
                  <Collapse in={this.state.code} timeout="auto" unmountOnExit>
                    <div>
                      <form style={formMarginBottom} autoComplete="off">
                        <div>
                          <div className="form-group">
                            <p className="form-input-label">
                              <FormattedMessage
                                id="LbHowToDefineID"
                                defaultMessage="How would you like to define employee ID?"
                              />
                            </p>

                            <div
                              className={`choose-section cursour-pointer input-area-section ${
                                this.state.modetypeid == 0 && "select-list-item"
                              }`}
                              onClick={this.UpdateModetype.bind(this, 0)}
                            >
                              <span style={{ marginLeft: 20 }}>
                                <FormattedMessage
                                  id="LbSpecifyItManually"
                                  defaultMessage="Specify it manually"
                                />
                              </span>
                              {this.state.modetypeid == 0 ? (
                                <span
                                  className="floatright"
                                  style={{ marginRight: 20 }}
                                >
                                  <img src={CheckImg} height="20" />
                                </span>
                              ) : (
                                <span className="not-selected margin-right-20"></span>
                              )}
                            </div>
                            <div
                              className={`choose-section cursour-pointer input-area-section ${
                                this.state.modetypeid == 1 && "select-list-item"
                              }`}
                              onClick={this.UpdateModetype.bind(this, 1)}
                            >
                              <span style={{ marginLeft: 20 }}>
                                <FormattedMessage
                                  id="LbAssignAutomatically"
                                  defaultMessage="Assign automatically"
                                />
                              </span>
                              {this.state.modetypeid == 1 ? (
                                <span
                                  className="floatright"
                                  style={{ marginRight: 20 }}
                                >
                                  <img src={CheckImg} height="20" />
                                </span>
                              ) : (
                                <span className="not-selected margin-right-20"></span>
                              )}
                            </div>

                            {this.state.permissions.editable && (
                              <Collapse
                                in={this.state.modetypeid == 0}
                                timeout="auto"
                                unmountOnExit
                              >
                                <div className="padding-top-30">
                                  <div className="position-rel">
                                    <div className="manually-upload-section">
                                      <Card style={{ marginLeft: 2 }}>
                                        <Link
                                          to={`../../../live_data/employeecode`}
                                          target="_blank"
                                        >
                                          <div
                                            className="padding-top-10"
                                            style={{ padding: 10 }}
                                          >
                                            {/* <img src={PlannerImg} height="50" /> */}
                                            <i className="material-icons muiicon">
                                              view_column
                                            </i>
                                          </div>
                                          <div style={{ padding: 10 }}>
                                            <FormattedMessage
                                              id="LbGoToLiveData"
                                              defaultMessage="GO TO LIVE DATA"
                                            />
                                          </div>
                                        </Link>
                                      </Card>
                                    </div>
                                  </div>
                                </div>
                              </Collapse>
                            )}
                          </div>
                        </div>
                        <div className="inner-wrapper " tabIndex="1">
                          <div>
                            <Collapse
                              in={this.state.show}
                              timeout="auto"
                              unmountOnExit
                            >
                              <div>
                                <Card style={{ width: 596, marginLeft: 2 }}>
                                  <div
                                    className="position-rel padding20 text-align-center inline-block"
                                    style={{ width: "94%" }}
                                  >
                                    <div className="inlineClass floatleft t-16 margin-top-6 text-color-grey">
                                      <Tooltip
                                        title={
                                          this.state.nextcode
                                            ? `Last Generated Employee ID: ${this.state.nextcode}`
                                            : ``
                                        }
                                      >
                                        <span>
                                          Preview : {this.state.Empcodepreview}
                                        </span>
                                      </Tooltip>
                                    </div>
                                    {this.state.permissions.editable && (
                                      <div
                                        style={{
                                          width: "310px",
                                          float: "right",
                                        }}
                                      >
                                        <span className="t-16 text-color-grey">
                                          Select a separator:
                                        </span>
                                        <Select
                                          style={{ width: "160px", left: 10 }}
                                          value={this.state.selectseperator}
                                          onChange={this.UpdateSeperatorValue.bind(
                                            this,
                                          )}
                                        >
                                          {this.state.seperatorOptions.map(
                                            (option) => (
                                              <MenuItem
                                                key="key"
                                                value={option.name}
                                              >
                                                {option.displayname}
                                                {option.name}
                                              </MenuItem>
                                            ),
                                          )}
                                        </Select>
                                      </div>
                                    )}
                                  </div>
                                </Card>
                                <div>
                                  {this.state.permissions.editable && (
                                    <Grid container>
                                      <Grid item xs={12} md={12} sm={12}>
                                        {this.state.list
                                          .slice(0, 3)
                                          .map((listData, column) => {
                                            const colName =
                                              column === 0
                                                ? "Select Prefix Type"
                                                : column === 1
                                                ? "Select Midtext Type"
                                                : "Select Suffix Type";
                                            // const defaultOption = { displayname: "-", displayvalue: -1, textValue: "" };
                                            // let selectedOption = defaultOption;
                                            let selectedOption = {
                                              displayname: "Company Name",
                                              displayvalue: 1,
                                              textValue: "Comapany Name",
                                            };
                                            let selectedOptionIndex = 0;
                                            listData.forEach((x, i) => {
                                              if (x.isSelected) {
                                                selectedOption = x;
                                                selectedOptionIndex = i;
                                              }
                                            });
                                            return (
                                              <Grid
                                                item
                                                xs={12}
                                                md={4}
                                                sm={12}
                                                key="key"
                                                className="floatleft width-33"
                                              >
                                                {column == 0 ? (
                                                  <div className="padding-top-30">
                                                    <Checkbox
                                                      checked={
                                                        this.state
                                                          .isPrifixSelected
                                                      }
                                                      onChange={this.FormatChange.bind(
                                                        this,
                                                        "isPrifixSelected",
                                                      )}
                                                      value={
                                                        this.state
                                                          .isPrifixSelected
                                                      }
                                                      color="primary"
                                                      className="no-padding emp-code-checkbox"
                                                    />
                                                    <span className="text-color-grey margin-left-4">
                                                      PREFIX TEXT
                                                    </span>
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                                {column == 1 ? (
                                                  <div className="padding-top-30">
                                                    <Checkbox
                                                      checked={
                                                        this.state
                                                          .isMidTextSelected
                                                      }
                                                      onChange={this.FormatChange.bind(
                                                        this,
                                                        "isMidTextSelected",
                                                      )}
                                                      value={
                                                        this.state
                                                          .isMidTextSelected
                                                      }
                                                      color="primary"
                                                      className="no-padding emp-code-checkbox"
                                                    />
                                                    <span className="text-color-grey margin-left-4 ">
                                                      <FormattedMessage
                                                        id="LbMidText"
                                                        defaultMessage="MID TEXT"
                                                      />
                                                    </span>
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                                {column == 2 ? (
                                                  <div className="padding-top-30">
                                                    <Checkbox
                                                      checked={
                                                        this.state
                                                          .isSuffixSelected
                                                      }
                                                      onChange={this.FormatChange.bind(
                                                        this,
                                                        "isSuffixSelected",
                                                      )}
                                                      value={
                                                        this.state
                                                          .isSuffixSelected
                                                      }
                                                      color="primary"
                                                      className="no-padding emp-code-checkbox"
                                                    />
                                                    <span className="text-color-grey margin-left-4">
                                                      <FormattedMessage
                                                        id="LbSuffixText"
                                                        defaultMessage="SUFFIX  TEXT"
                                                      />
                                                    </span>
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                                <div className="emp-code-generator-section">
                                                  <div className="select-question margin-top-10">
                                                    <div>
                                                      {/* <span style={{ padding: "0 20px", fontSize: 16 }}>
                                                    {`What data do you want in Prefix Text?`}
                                                  </span> */}
                                                      <span
                                                        style={{
                                                          display: "block",
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        {column === 0 && (
                                                          <FormControl
                                                            style={{
                                                              width: "85%",
                                                            }}
                                                          >
                                                            <InputLabel htmlFor="age-simple">
                                                              {colName}
                                                            </InputLabel>
                                                            <Select
                                                              placeholder="Select option"
                                                              style={{
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                              value={
                                                                selectedOption
                                                              }
                                                              onChange={this.FormatSelection.bind(
                                                                this,
                                                                selectedOption,
                                                                listData,
                                                                selectedOptionIndex,
                                                                column,
                                                              )}
                                                              disabled={
                                                                !this.state
                                                                  .isPrifixSelected
                                                              }
                                                            >
                                                              {/* <MenuItem value={defaultOption}>
                                                          <em>Select option</em>
                                                        </MenuItem> */}
                                                              {listData.map(
                                                                (data, row) => (
                                                                  <MenuItem
                                                                    key="key"
                                                                    value={data}
                                                                  >
                                                                    {
                                                                      data.displayname
                                                                    }
                                                                  </MenuItem>
                                                                ),
                                                              )}
                                                            </Select>
                                                          </FormControl>
                                                        )}
                                                        {column === 1 && (
                                                          <FormControl
                                                            style={{
                                                              width: "85%",
                                                            }}
                                                          >
                                                            <InputLabel htmlFor="age-simple">
                                                              {colName}
                                                            </InputLabel>
                                                            <Select
                                                              placeholder="Select option"
                                                              style={{
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                              value={
                                                                selectedOption
                                                              }
                                                              onChange={this.FormatSelection.bind(
                                                                this,
                                                                selectedOption,
                                                                listData,
                                                                selectedOptionIndex,
                                                                column,
                                                              )}
                                                              disabled={
                                                                !this.state
                                                                  .isMidTextSelected
                                                              }
                                                            >
                                                              {/* <MenuItem value={defaultOption}>
                                                          <em>Select option</em>
                                                        </MenuItem> */}
                                                              {listData.map(
                                                                (data, row) => (
                                                                  <MenuItem
                                                                    key="key"
                                                                    value={data}
                                                                  >
                                                                    {
                                                                      data.displayname
                                                                    }
                                                                  </MenuItem>
                                                                ),
                                                              )}
                                                            </Select>
                                                          </FormControl>
                                                        )}
                                                        {column === 2 && (
                                                          <FormControl
                                                            style={{
                                                              width: "85%",
                                                            }}
                                                          >
                                                            <InputLabel htmlFor="age-simple">
                                                              {colName}
                                                            </InputLabel>
                                                            <Select
                                                              placeholder="Select option"
                                                              style={{
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                              value={
                                                                selectedOption
                                                              }
                                                              onChange={this.FormatSelection.bind(
                                                                this,
                                                                selectedOption,
                                                                listData,
                                                                selectedOptionIndex,
                                                                column,
                                                              )}
                                                              disabled={
                                                                !this.state
                                                                  .isSuffixSelected
                                                              }
                                                            >
                                                              {/* <MenuItem value={defaultOption}>
                                                          <em>Select option</em>
                                                        </MenuItem> */}
                                                              {listData.map(
                                                                (data, row) => (
                                                                  <MenuItem
                                                                    key="key"
                                                                    value={data}
                                                                  >
                                                                    {
                                                                      data.displayname
                                                                    }
                                                                  </MenuItem>
                                                                ),
                                                              )}
                                                            </Select>
                                                          </FormControl>
                                                        )}
                                                        {/* <Select
                                                      value={selectedOption}
                                                      onChange={this.FormatSelection.bind(
                                                        this,
                                                        selectedOption,
                                                        listData,
                                                        selectedOptionIndex,
                                                        column
                                                      )}
                                                    >
                                                      {listData.map((data, row) => {
                                                        return (
                                                          <MenuItem value={data}>
                                                            {data.displayname}
                                                          </MenuItem>
                                                        );
                                                      })}
                                                    </Select> */}
                                                      </span>
                                                    </div>
                                                    {/* <div style={{ marginTop: 15 }}>
                                                  <span style={{ padding: "0 20px", fontSize: 16 }}>
                                                    How many alphabates do you want in <br />
                                                    <span style={{ paddingLeft: 20 }}>
                                                      {get(selectedOption, "displayname", "")}
                                                    </span>
                                                  </span>
                                                </div> */}
                                                    <div className="padding-left-24 padding-right-24">
                                                      {this.getInputComponent(
                                                        selectedOption,
                                                        listData,
                                                        selectedOptionIndex,
                                                        column,
                                                      )}
                                                    </div>
                                                  </div>

                                                  <div className="position-rel padding-left-20 margin-top-8">
                                                    <div className="code-generator-label margin-top-8 floatleft t-14">
                                                      <FormattedMessage
                                                        id="LbAllUpperCase"
                                                        defaultMessage="All Upper case"
                                                      />
                                                    </div>
                                                    <div>
                                                      <Switch
                                                        checked={
                                                          listData.isUppercaseSelected
                                                        }
                                                        onChange={this.UppercaseSelection.bind(
                                                          this,
                                                          listData,
                                                          column,
                                                        )}
                                                        value={
                                                          listData.isUppercaseSelected
                                                        }
                                                        name={column}
                                                        color="primary"
                                                      />
                                                    </div>
                                                    <div className="clear-float"></div>
                                                  </div>
                                                </div>

                                                <div className="emp-code-generator-section display-none">
                                                  <div>
                                                    {listData.map(
                                                      (data, row) => (
                                                        <div key="key">
                                                          {row ? (
                                                            <div className="custom-prefix-divider">
                                                              <div className="inlineClass">
                                                                <Radio
                                                                  checked={
                                                                    data.isSelected
                                                                  }
                                                                  disabled={
                                                                    listData.isDisabled
                                                                  }
                                                                  onChange={this.FormatSelection.bind(
                                                                    this,
                                                                    data,
                                                                    listData,
                                                                    row,
                                                                    column,
                                                                  )}
                                                                  value={
                                                                    data.name
                                                                  }
                                                                  color="primary"
                                                                  className="emp-radiobutton-width"
                                                                />
                                                              </div>
                                                              {data.displayvalue ==
                                                              6 ? (
                                                                <div className="inlineClass emp-code-input-range">
                                                                  <div className="inlineClass">
                                                                    <span className="code-generator-label">
                                                                      <FormattedMessage
                                                                        id={
                                                                          data.key
                                                                        }
                                                                        defaultMessage={
                                                                          data.displayname
                                                                        }
                                                                      />
                                                                    </span>
                                                                  </div>
                                                                  {/* vxcvxcxc */}
                                                                  <InputNumber
                                                                    min={1}
                                                                    maxLength="10"
                                                                    value={
                                                                      data.textValue
                                                                    }
                                                                    disabled={
                                                                      listData.isDisabled
                                                                    }
                                                                    onChange={(
                                                                      event,
                                                                    ) =>
                                                                      this.OnNumberSeriesChange(
                                                                        data,
                                                                        listData,
                                                                        row,
                                                                        column,
                                                                        event,
                                                                      )
                                                                    }
                                                                    onKeydown={this.HandleKeyDown.bind(
                                                                      this,
                                                                    )}
                                                                  />
                                                                  {/* <input
                                                                type="number"
                                                                min={1}
                                                                value={data.textValue}
                                                                disabled={listData.isDisabled}
                                                                onChange={this.OnNumberSeriesChange.bind(
                                                                  this,
                                                                  data,
                                                                  listData,
                                                                  row,
                                                                  column
                                                                )}
                                                                onKeyDown={this.HandleKeyDown.bind(
                                                                  this
                                                                )}
                                                                maxLength="10"
                                                                className="emp-code-input"
                                                              /> */}
                                                                </div>
                                                              ) : (
                                                                <div className="inlineClass">
                                                                  <div className="inlineClass">
                                                                    <span className="code-generator-label">
                                                                      <FormattedMessage
                                                                        id={
                                                                          data.key2
                                                                        }
                                                                        defaultMessage={
                                                                          data.key2name
                                                                        }
                                                                      />
                                                                    </span>
                                                                  </div>
                                                                  {data.displayvalue ==
                                                                  5 ? (
                                                                    <div className="inlineClass">
                                                                      <input
                                                                        type="text"
                                                                        value={
                                                                          data.textValue
                                                                        }
                                                                        disabled={
                                                                          listData.isDisabled
                                                                        }
                                                                        onChange={this.OnTextChange.bind(
                                                                          this,
                                                                          data,
                                                                          listData,
                                                                          row,
                                                                          column,
                                                                        )}
                                                                        maxLength="10"
                                                                      />
                                                                    </div>
                                                                  ) : (
                                                                    <div className="inlineClass emp-code-input-range">
                                                                      <InputNumber
                                                                        min={1}
                                                                        maxLength="10"
                                                                        value={
                                                                          data.textValue
                                                                        }
                                                                        disabled={
                                                                          listData.isDisabled
                                                                        }
                                                                        onChange={(
                                                                          event,
                                                                        ) =>
                                                                          this.OnNumberSeriesChange(
                                                                            data,
                                                                            listData,
                                                                            row,
                                                                            column,
                                                                            event,
                                                                          )
                                                                        }
                                                                        onKeydown={this.HandleKeyDown.bind(
                                                                          this,
                                                                        )}
                                                                      />
                                                                    </div>
                                                                    // <div className="inlineClass">
                                                                    //   <input
                                                                    //     type="number"
                                                                    //     min={1}
                                                                    //     max={10}
                                                                    //     value={data.textValue}
                                                                    //     disabled={listData.isDisabled}
                                                                    //     // onBlur={this.HandleInvalidNumber.bind(this, data, listData, row, column)}
                                                                    //     onChange={this.OnNumberChange.bind(
                                                                    //       this,
                                                                    //       data,
                                                                    //       listData,
                                                                    //       row,
                                                                    //       column
                                                                    //     )}
                                                                    //     onKeyDown={this.HandleKeyDown.bind(
                                                                    //       this
                                                                    //     )}
                                                                    //     className="emp-code-input"
                                                                    //   />
                                                                    // </div>
                                                                  )}
                                                                  <div className="inlineClass">
                                                                    <span className="code-generator-label">
                                                                      <FormattedMessage
                                                                        id={
                                                                          data.key
                                                                        }
                                                                        defaultMessage={
                                                                          data.displayname
                                                                        }
                                                                      />
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                              )}
                                                            </div>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </div>
                                                      ),
                                                    )}
                                                    <Divider />

                                                    <div className="padding-top-20 padding-bottom-10 position-rel">
                                                      <div className="code-generator-label">
                                                        <FormattedMessage
                                                          id="LbAllUpperCase"
                                                          defaultMessage="All Upper case"
                                                        />
                                                      </div>
                                                      <div className="padding-top-8">
                                                        <Switch
                                                          checked={
                                                            listData.isUppercaseSelected
                                                          }
                                                          onChange={this.UppercaseSelection.bind(
                                                            this,
                                                            listData,
                                                            column,
                                                          )}
                                                          value={
                                                            listData.isUppercaseSelected
                                                          }
                                                          name={column}
                                                          color="primary"
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </Grid>
                                            );
                                          })}
                                      </Grid>
                                    </Grid>
                                  )}
                                </div>
                              </div>
                              {this.state.permissions.editable && (
                                <div className="padding-top-30 form-group">
                                  <input
                                    type="text"
                                    className="visibilitynone"
                                  />
                                  <p className="form-input-label">
                                    <FormattedMessage
                                      id="LbHowToAssignID"
                                      defaultMessage="How do we assign these IDs to the existing employees?"
                                    />
                                  </p>

                                  <div
                                    className={`choose-section cursour-pointer input-area-section ${
                                      this.state.assignmenttypeid == 1 &&
                                      "select-list-item"
                                    }`}
                                    onClick={this.UpdateAssignmenttype.bind(
                                      this,
                                      1,
                                    )}
                                  >
                                    <span style={{ marginLeft: 20 }}>
                                      <FormattedMessage
                                        id="LbStartFromOldestJoiningDate"
                                        defaultMessage="Start from the oldest joining date"
                                      />
                                    </span>
                                    {this.state.assignmenttypeid == 1 ? (
                                      <span
                                        className="floatright"
                                        style={{ marginRight: 20 }}
                                      >
                                        <img src={CheckImg} height="20" />
                                      </span>
                                    ) : (
                                      <span className="not-selected margin-right-20"></span>
                                    )}
                                  </div>

                                  <Collapse
                                    in={this.state.hide}
                                    timeout="auto"
                                    unmountOnExit
                                    style={{ width: 550, marginLeft: 25 }}
                                  >
                                    <div className="padding-top-20">
                                      <div className="position-rel">
                                        <p className="form-input-label">
                                          <FormattedMessage
                                            id="LbWouldYouLikeToIncludeDeactivatedEmployees?"
                                            defaultMessage="Would you like to include deactivated employees?"
                                          />
                                        </p>
                                        <div>
                                          <SelectList
                                            data={options}
                                            Selected={
                                              this.state.isincludedeactiveemp
                                            }
                                            onSelected={this.UpdateDeactivateEmp.bind(
                                              this,
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </Collapse>
                                  <div
                                    className={`choose-section cursour-pointer input-area-section ${
                                      this.state.assignmenttypeid == 2 &&
                                      "select-list-item"
                                    }`}
                                    onClick={this.UpdateAssignmenttype.bind(
                                      this,
                                      2,
                                    )}
                                  >
                                    <span style={{ marginLeft: 20 }}>
                                      <FormattedMessage
                                        id="LbContinueSeriesForAllFutureEmployees"
                                        defaultMessage="Continue series for all future employees"
                                      />
                                    </span>
                                    {this.state.assignmenttypeid == 2 ? (
                                      <span
                                        className="floatright"
                                        style={{ marginRight: 20 }}
                                      >
                                        <img src={CheckImg} height="20" />
                                      </span>
                                    ) : (
                                      <span className="not-selected margin-right-20"></span>
                                    )}
                                  </div>
                                </div>
                              )}
                            </Collapse>
                          </div>
                        </div>
                        <div className="inner-wrapper" tabIndex="2">
                          <div className="upform-footer">
                            {this.state.permissions.editable ? (
                              <div>
                                {/* {this.state.modetypeid == 1 ? ( */}
                                <div
                                  className="form-btn form-control"
                                  onClick={this.OnSubmit.bind(this)}
                                >
                                  <FormattedMessage
                                    id="BtSubmit"
                                    defaultMessage="SAVE"
                                  />
                                </div>
                                {/* ) : (
                                  <div className="form-btn form-control hideButton">
                                    <FormattedMessage id="BtSubmit" defaultMessage="Hide save" />
                                  </div>
                                )} */}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </form>
                    </div>
                  </Collapse>

                  <Collapse
                    in={this.state.preview}
                    timeout="auto"
                    unmountOnExit
                  >
                    <div id="divpreview">
                      <div className="emp-code-preview-label">
                        <FormattedMessage
                          id="LbPreview"
                          defaultMessage="Preview ?"
                        />
                      </div>
                      {this.state.preview == true ? (
                        <div className="">
                          {this.state.empcodepreviewlist.map((data) => (
                            <div key="key">
                              <div className="emp-code-preview padding-top-40">
                                <Grid container>
                                  <Grid item xs={12} md={6} sm={6}>
                                    <div className="position-rel">
                                      <div className="dir-emp-img">
                                        {data.imagepath ? (
                                          <img
                                            className="dir-profile-img"
                                            src={getFormattedImageLink(
                                              data.imagepath,
                                            )}
                                            height="83"
                                          />
                                        ) : (
                                          <img
                                            className="dir-profile-img"
                                            src={defaultEmp}
                                            height="83"
                                          />
                                        )}
                                      </div>
                                      <div className="dir-emp-info">
                                        <p className="no-padding">
                                          <strong>{data.employeename}</strong>
                                        </p>
                                        <p className="padding-top-10">
                                          <span>
                                            <img
                                              src={Bag}
                                              className="indicator-icon"
                                            />
                                          </span>
                                          <span className="margin-left-8">
                                            {data.designation}
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Grid item xs={12} md={3} sm={3}>
                                    <div className="inlineClass padding-top-50">
                                      <p>
                                        <img
                                          src={Bag}
                                          className="indicator-icon"
                                        />
                                        <span className="margin-left-8">
                                          {data.department}
                                        </span>
                                      </p>
                                    </div>
                                  </Grid>
                                  <Grid item xs={12} md={3} sm={3}>
                                    <p className="padding-top-50">
                                      <span>
                                        <img
                                          src={Bag}
                                          className="indicator-icon"
                                        />
                                      </span>
                                      <span className="margin-left-8">
                                        {data.employeecode}
                                      </span>
                                    </p>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          ))}
                          <div className="upform-footer padding-bottom-30">
                            <div
                              className="form-btn form-control inlineClass margin-right-10"
                              onClick={this.AssignEmpCode.bind(this)}
                              style={{ width: 350 }}
                            >
                              <FormattedMessage
                                id="BtAssign"
                                defaultMessage="update for existing employee"
                              />
                            </div>
                            {this.state.permissions.editable ? (
                              <div
                                className="form-btn form-control inlineClass"
                                onClick={this.EditCode.bind(this)}
                              >
                                <FormattedMessage
                                  id="BtEdit"
                                  defaultMessage="Go back"
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </Collapse>
                </div>
              </Grid>
            </div>
          )}
        </main>
      </IntlProvider>
    );
  }
}

EmpCode.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(EmpCode)));
